import {CookieList} from '@/modules/finkn/content-blocks/components/cookie-list';
import type {CookieListFragment} from '@/modules/finkn/content-blocks/sanity/cookie-list/query';

type Props = {
	data: CookieListFragment;
	fullWidth?: boolean;
	insideToc?: boolean;
};

export const CookieListContainer = ({data, fullWidth, insideToc}: Props) => {
	return <CookieList options={{fullWidth, ...data?.contentBlockOptions}} insideToc={insideToc} />;
};
